import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import compositeId from '../../compositeId'

const getId = compositeId('typeDescriptorId', 'id')

export const collection = 'connectorValues'
export const schema = new schemas.Entity(
  collection,
  {},
  {
    idAttribute: (value) => getId(value),
  }
)

type FetchQueryType = {
  connectorDataSourceId: string
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ connectorDataSourceId, id }: FetchQueryType) =>
    callApi(
      `${apiBase}/connectorTypes/${connectorDataSourceId}/${id}/actions/name`,
      schema
    )
